export default __webpack_public_path__ + "src/docs/packages/easterncape.pdf";